import { RESET_ALL_STATES } from '@/redux/mutations';

/**
 * Action para limpar todos os estados do Redux
 * Útil para logout completo da aplicação
 */
export const resetAllStates = () => ({
    type: RESET_ALL_STATES
});
